import { useState } from 'react'
import { Container, Navbar } from '@postenbring/hedwig-react'
import { MenuMainContent } from './menu-content'
import { MenuIconSection } from './menu-icon-section'
import { Search } from './search/search'
import { SearchIcon } from './search/searchIcon'
import { CloseIcon } from './closeIcon'
import { UserIcon } from '../../shared/icon/user-icon'

export const PostenNavbar = ({ headerData, trackingUrl }) => {
    const [showSearchInput, setShowSearchInput] = useState(false)

    return (
        <>
            <Navbar
                className='kp-header'
                data-state={showSearchInput ? 'search-open' : 'search-closed'}
                variant={headerData.flagShip ? 'service' : ''}
            >
                {headerData.flagShip && (
                    <Navbar.LogoAndServiceText
                        variant='flagship'
                        data-state={
                            showSearchInput
                                ? 'hidden-on-search-open'
                                : 'visible'
                        }
                    >
                        <a href='/' title={headerData.toFrontPage}>
                            {headerData.flagShip}
                        </a>
                    </Navbar.LogoAndServiceText>
                )}

                {!headerData.flagShip && (
                    <Navbar.Logo
                        asChild
                        className='kp-header-logo'
                        data-state={
                            showSearchInput
                                ? 'hidden-on-search-open'
                                : 'visible'
                        }
                    >
                        <a href='/' title={headerData.toFrontPage} />
                    </Navbar.Logo>
                )}
                {headerData.postenBringDesign && (
                    <a
                        href='/'
                        className='kp-header-postenbring hds-text-h3-title'
                    >
                        Posten Bring
                    </a>
                )}
                <Navbar.Navigation className='kp-header-navbar'>
                    {showSearchInput ? (
                        <>
                            <Search headerData={headerData} trackingUrl={trackingUrl} />
                            <Navbar.ButtonItem
                                className='kp-header-main-nav-item kp-header-search-close'
                                aria-expanded={showSearchInput}
                                onClick={() => setShowSearchInput(false)}
                            >
                                <CloseIcon />
                            </Navbar.ButtonItem>
                        </>
                    ) : (
                        <>
                            <Navbar.ButtonItem
                                title='Button'
                                className='kp-hidden-before-large'
                                onClick={() => setShowSearchInput(true)}
                            >
                                {headerData.searchButtonLabel}
                                <SearchIcon />
                            </Navbar.ButtonItem>
                            <Navbar.ButtonItem
                                className='kp-hidden-after-large kp-decorator-header-main-nav-item'
                                aria-expanded={showSearchInput}
                                title={headerData.searchButtonLabel}
                                onClick={() => {
                                    setShowSearchInput(true)
                                }}
                            >
                                <SearchIcon />
                            </Navbar.ButtonItem>
                        </>
                    )}

                    {headerData.loginLinks &&
                        headerData.loginLinks.length > 0 && (
                            <Navbar.LinkItem
                                className='kp-navbar-link kp-hidden-before-large'
                                title={headerData.loginLinks[0].title}
                                href={headerData.loginLinks[0].url}
                            >
                                {headerData.loginLinks[0].title}
                                <UserIcon />
                            </Navbar.LinkItem>
                        )}
                    <Navbar.ExpandableMenu className='kp-header-menu'>
                        <Navbar.ExpandableMenuTrigger
                            data-state={
                                showSearchInput
                                    ? 'hidden-on-search-open'
                                    : 'visible'
                            }
                            whenClosedText={headerData.menuLabel}
                            whenOpenText={headerData.closeMenuLabel}
                        />
                        <Navbar.ExpandableMenuContent>
                            <Container>
                                <MenuIconSection
                                    content={headerData.iconSection}
                                    login={headerData.loginLinks}
                                />
                                <MenuMainContent
                                    mainContent={headerData.mainSections}
                                />
                            </Container>
                        </Navbar.ExpandableMenuContent>
                    </Navbar.ExpandableMenu>
                </Navbar.Navigation>
            </Navbar>
            <div
                className='kp-header-overlay'
                data-state={showSearchInput ? 'active' : 'closed'}
            />
        </>
    )
}
